import { Container, AnimatedSprite, Texture } from 'pixi.js';
import { Tween, Easing } from '@tweenjs/tween.js';

import Point from './Point';

class Coin extends Container {
	currentDir = false;
	p0 = { x: 0, y: 0 };
	c0 = { x: 0, y: 0 };
	c1 = { x: 0, y: 0 };
	p1 = { x: 0, y: 0 };

	constructor(dir, fc) {
		super();
		this.currentDir = dir;
		///coin_right_00000
		//coinanima  00->17
		//coinanimb,c,d  00->19

		let anims = [
			{ name: 'coinanima', len: 17 },
			{ name: 'coinanimb', len: 19 },
			{ name: 'coinanimc', len: 19 },
			{ name: 'coinanimd', len: 19 }
		];

		let rndpattern = anims[Math.floor(Math.random() * anims.length)];

		const textureArray = [];

		for (let i = 0; i <= rndpattern.len; i += 1) {
			let current = rndpattern.name + String(i).padStart(2, '0') + '.png';
			const texture = Texture.from(current);
			textureArray.push(texture);
		}

		this.anim = new AnimatedSprite(textureArray);
		this.anim.loop = true;
		this.anim.animationSpeed = 1;
		this.anim.play();

		let w = fc.minWidth + Math.random() * fc.width;
		let h = fc.minHeight + Math.random() * fc.height;
		this.p0 = { x: this.currentDir ? w * 0.1 : -w * 0.1, y: 0 };

		this.c0 = {
			x: this.currentDir ? w * 0.3 * Math.random() : -w * 0.3 * Math.random(),
			y: -h * 0.8
		};

		this.c1 = {
			x: this.currentDir ? w * 0.7 * Math.random() : -w * 0.7 * Math.random(),
			y: -h * 0.8
		};

		this.p1 = {
			x: this.currentDir
				? w * (0.3 + Math.random())
				: -w * (0.3 + Math.random()),
			y: 800
		};

		var twObj = { progress: 0 };
		new Tween(twObj)
			.to({ progress: 1 }, 1000)
			.easing(Easing.Linear.None)
			.delay(200 * Math.random())
			.onStart(() => {
				this.addChild(this.anim);
			})
			.onUpdate(() => {
				var p = Point.fromBezier(
					[this.p0, this.c0, this.c1, this.p1],
					twObj.progress
				);
				this.x = p.x;
				this.y = p.y;
			})
			.onComplete(() => {
				this.anim.stop();
				this.anim.destroy();
				this.removeChild(this.anim);
				if (this.parent) {
					this.parent.removeChild(this);
				}
			})
			.start();
	}
}

export default Coin;
